function isValidMonth(value: number): boolean {
	return value >= 1 && value <= 12;
}

/**
 * Normalizes card expiry to MMYY (4 digits) for `card.date` / panel display.
 * Accepts separators; Unired may return YYMM (e.g. "2803" → "0328") or MMYY ("03/28" → "0328").
 */
export function normalizeBalanceExpireMmyy(date: string | null | undefined): string | null {
	if (!date?.trim()) {
		return null;
	}
	const compact = date.replace(/[\s/.-]/g, '');
	if (!/^\d{4}$/.test(compact)) {
		return null;
	}

	const first = Number(compact.slice(0, 2));
	const last = Number(compact.slice(2, 4));

	if (isValidMonth(first)) {
		return compact;
	}
	if (isValidMonth(last) && first <= 29) {
		return compact.slice(2, 4) + compact.slice(0, 2);
	}
	if (!isValidMonth(last)) {
		return null;
	}

	// Legacy passthrough (e.g. Korzinka wire "3105" stored as-is when month position is ambiguous)
	return compact;
}

/**
 * Normalizes card expiry to YYMM (4 digits) for Korzinka balance API (`expire` on `/bank/card/add`).
 * `card.date` is MMYY; this swaps to API wire format (year then month).
 */
export function normalizeBalanceExpireYymm(date: string | null | undefined): string | null {
	if (!date?.trim()) {
		return null;
	}
	const compact = date.replace(/[\s/.-]/g, '');
	if (!/^\d{4}$/.test(compact)) {
		return null;
	}

	const first = Number(compact.slice(0, 2));
	const last = Number(compact.slice(2, 4));

	if (isValidMonth(first)) {
		return compact.slice(2, 4) + compact.slice(0, 2);
	}
	if (isValidMonth(last) && first <= 29) {
		return compact;
	}
	if (!isValidMonth(last)) {
		return null;
	}

	return compact;
}

/** @deprecated Prefer normalizeBalanceExpireMmyy for storage; normalizeBalanceExpireYymm for balance API. */
export function passthroughBalanceExpire(date: string | null | undefined): string | null {
	return normalizeBalanceExpireMmyy(date);
}
